module.exports = __webpack_public_path__ + "static/helm_of_telepathy-fb5911f25aad2004a4dfcac4aa1af775.jpeg";